<template>
    <div class="photo-source-picker d-flex flex-wrap" :class="{ 'd-inline-flex': compact, 'photo-source-buttons': !compact }">
        <label v-if="hasTouch" :class="buttonClasses('camera')">
            <i class="las la-camera la-lg mr-1"></i>{{ cameraLabel }}
            <input type="file" accept="image/*" :capture="capture" class="photo-source-input" :disabled="disabled" @change="onChange">
        </label>
        <label :class="buttonClasses('gallery')">
            <i class="las la-image la-lg mr-1"></i>{{ hasTouch ? galleryLabel : desktopLabel }}
            <input type="file" :accept="accept" class="photo-source-input" :disabled="disabled" @change="onChange">
        </label>
    </div>
</template>

<script>
/**
 * Two ways to add a picture on phones: straight from the camera, or from the
 * gallery/files. Desktop browsers ignore `capture`, so they get the file picker only.
 * Primary pointer (not any-pointer) so touchscreen laptops count as desktop; on iOS the
 * gallery picker still offers "Take Photo" if the camera button is ever hidden.
 */
export default {
    props: {
        accept: { type: String, default: 'image/*' },
        capture: { type: String, default: 'environment' },
        cameraLabel: { type: String, default: 'Take photo' },
        galleryLabel: { type: String, default: 'Gallery' },
        desktopLabel: { type: String, default: 'Choose photo' },
        compact: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
    },
    data() {
        return {
            hasTouch: typeof window !== 'undefined'
                && typeof window.matchMedia === 'function'
                && window.matchMedia('(pointer: coarse)').matches,
        };
    },
    methods: {
        buttonClasses(source) {
            const base = this.compact
                ? ['btn', 'btn-link', 'btn-sm', 'p-0', 'mb-0', 'mr-3', 'photo-source-link']
                : ['btn', 'mb-0', 'flex-fill', 'photo-source-btn', source === 'camera' ? 'btn-primary' : 'btn-outline-primary'];

            if (this.disabled) {
                base.push('disabled');
            }
            return base;
        },
        onChange(event) {
            const file = event.target.files[0] || null;
            event.target.value = '';

            if (file) {
                this.$emit('selected', file);
            }
        },
    },
};
</script>

<style scoped>
.photo-source-buttons {
    gap: 8px;
}
/* Visually hidden but still opens the camera/photo picker when its label is tapped (iOS needs it rendered) */
.photo-source-input {
    position: absolute;
    width: 1px;
    height: 1px;
    opacity: 0;
    overflow: hidden;
}
.photo-source-btn,
.photo-source-link {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 44px;
    white-space: nowrap;
}
</style>
